const textFieldFormCreateUser = {
  email: 'Email',
  confirmationEmail: 'Confirme o Email',
  helperTextEmail: 'O convite sera enviado para este email',
  helperTextConfirmationEmail: 'Emails estão diferentes'
};

export default textFieldFormCreateUser;
